<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items="items"
  item-value='name'
  item-text='name'
)
</template>

<script>
import picker from '@/mixins/picker'

export default {
  data() {
    return {
      items: [
        { name: 'Полная занятость' },
        { name: 'Частичная занятость' },
        { name: 'Проектная работа' },
        { name: 'Стажировка' }
      ]
    }
  },
  mixins: [picker],
  props: {
    label: {
      selected: 1
    }
  }
}
</script>
